let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Qf26i")).then(() => parcelRequire('kunlT'));